import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { DatePipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  INJECTOR,
  input,
  model,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  SearchResultRenderer,
  ShellSearchService,
  SOFT_SHELL_SAVE_LAST_VIEWED,
  SOFT_SHELL_SEARCH_DISMISS,
} from '@softapps/core';
import { IconComponent, TranslatePipe } from '@softline/ui-core';
import { PersonalUebersicht } from '../../types/abteilung';

@Component({
  selector: 'soft-employee-search-result',
  imports: [DatePipe, NgClass, IconComponent, TranslatePipe],
  templateUrl: './employee-search-result.component.html',
  styleUrl: './employee-search-result.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(keydown.enter)': 'openMitarbeiterDetailView(this.result())',
  },
})
export class MitarbeiterSearchResult extends SearchResultRenderer<PersonalUebersicht> {
  override result = input.required<PersonalUebersicht>();
  override highlighted = input(false);
  override disabled = model(false);

  readonly router = inject(Router);
  readonly injector = inject(INJECTOR);
  readonly overlay = inject(CdkConnectedOverlay);
  readonly shellSearchService = inject(ShellSearchService);

  readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);
  readonly saveLastViewed = inject(SOFT_SHELL_SAVE_LAST_VIEWED, { optional: true });

  async openMitarbeiterDetailView(result: PersonalUebersicht) {
    this.saveLastViewed?.({
      key: String(result.id),
      title: `${result.anwender.firstName} ${result.anwender.lastName}`,
      description: result.anwender.user,
      url: `/statusabfrage/abteilung/${result.abteilung.id}/detail/${result.id}`,
    });
    this.dismissSearchOverlay();
    await this.router.navigate(
      ['/statusabfrage/abteilung', result.abteilung.id, 'detail', result.id],
      { state: { fromSearch: true } }
    );
  }
}
